import React from 'react';
import PanelAppearance from '../../containers/handoff/PanelAppearance';
import PanelProperties from '../../containers/handoff/PanelProperties';
import PanelBorder from '../../containers/handoff/PanelBorder';
import PanelCode from '../../containers/handoff/PanelCode';
import PanelShadows from '../../containers/handoff/PanelShadows';
export default function HandoffGroup() {
    return (React.createElement("div", null,
        React.createElement(PanelProperties, null),
        React.createElement(PanelAppearance, null),
        React.createElement(PanelBorder, null),
        React.createElement(PanelShadows, null),
        React.createElement(PanelCode, null)));
}
